import RoutesMap from 'route_control/RouteControl'
import { AssetList, AssetServiceList, AssetInwardList, ScheduleList, JobCardList, WorkOrderList, AdminMaintenance } from 'pages/maintenance'

const MaintenanceRoute = () => {
    return [
        {
            path: RoutesMap.ASSET_LIST.path,
            element: <AssetList />,
        },
        {
            path: RoutesMap.ASSET_SERVICE_LIST.path,
            element: <AssetServiceList />,
        },
        {
            path: RoutesMap.ASSET_INWARD_LIST.path,
            element: <AssetInwardList />,
        },
        {
            path: RoutesMap.SCHEDULE_LIST.path,
            element: <ScheduleList />,
        },
        {
            path: RoutesMap.JOB_CARD_LIST.path,
            element: <JobCardList />,
        },
        {
            path: RoutesMap.WORK_ORDER_LIST.path,
            element: <WorkOrderList />,
        },
        {
            path: RoutesMap.ADMIN_MAINTENANCE.path,
            element: <AdminMaintenance />,
        },
    ]
}

export default MaintenanceRoute;